import {BuildOutlined, DeleteOutlined, PlusOutlined} from '@ant-design/icons'
import {InputNumber, Radio, Space, Button as AntdButton} from 'antd'
import React from 'react'
import {Element, TypedElement} from '../../../../entities/project'
import {useIntl} from 'react-intl'
import {TransformerUIManager} from '../../transformerUis/TransformerUIManager'

// export function CalculateEdges(points: number[]) {
//   let edges = []
//   let xDif = 0
//   let yDif = 0
//   for (let i = 0; i < points.length - 1; i += 2) {
//     if (i === points.length - 2) {
//       xDif = points[i] - points[0]
//       yDif = points[i + 1] - points[1]
//     } else {
//       xDif = points[i] - points[i + 2]
//       yDif = points[i + 1] - points[i + 3]
//     }
//     edges.push(Math.sqrt(xDif * xDif + yDif * yDif))
//   }
//   return edges as number[]
// }

// export function DeletePoint(edgeNumber: number, points: number[]) {
//   let newPoints = points
//   if ((edgeNumber + 1) * 2 === points.length) {
//     newPoints.splice(0, 2)
//   } else {
//     let newPoints = points
//     newPoints.splice(edgeNumber * 2 + 2, 2)
//   }
//   return newPoints as number[]
// }

// export function AddPoint(edgeNumber: number, points: number[]) {
//   let newPoints = points
//   let x = (points[edgeNumber * 2 + 2] - points[edgeNumber * 2]) / 2 + points[edgeNumber * 2]
//   let y = (points[edgeNumber * 2 + 3] - points[edgeNumber * 2 + 1]) / 2 + points[edgeNumber * 2 + 1]
//   newPoints.splice(edgeNumber * 2 + 2, 0, x, y)

//   return newPoints as number[]
// }

export type EditorCreatePlotArbitraryProps = {
  plot?: Element
  isToolSelected: boolean
  onToolSelected: () => void
  onPlotUpdated: (updatedElement: TypedElement) => void
  transformerProps?: any
  onTransformerPropsChange?: (newProps: any) => void
}

export function EditorCreatePlotArbitrary(props: EditorCreatePlotArbitraryProps) {
  let sides = []
  // if (props.plot && props.plot.shapeType === 'polygon') {
  //   sides = CalculateEdges(props.plot?.props.points)
  // }

  const intl = useIntl()

  return (
    <div>
      <div className="editor-fields-name">{intl.formatMessage({id: 'usePlotDrawingTool'})}:</div>
      <Radio.Group value={props.isToolSelected ? 1 : null} style={{paddingBottom: '15px'}}>
        <Radio.Button
          className="editor-fields-radio"
          value={1}
          onClick={props.onToolSelected}
          style={{height: 65}}
        >
          <div className="editor-fields-radio-icon">
            <BuildOutlined />
          </div>
        </Radio.Button>
      </Radio.Group>

      {/* <Space direction="vertical">
        {props.plot && (
          <div className="editor-fields-name">
            {intl.formatMessage({id: 'enterPlotEdgesDimensions'})}:
          </div>
        )}
        {sides.map((side, index) => (
          <div key={index}>
            <InputNumber
              style={{width: '100%'}}
              addonBefore={`${intl.formatMessage({id: 'edge'})} ${index + 1}`}
              addonAfter="м"
              defaultValue={side}
            />
            <AntdButton
              type="link"
              style={{float: 'right'}}
              onClick={async () => {
                DeletePoint(index, props.plot?.props.points)
              }}
            >
              <DeleteOutlined />
            </AntdButton>

            <AntdButton
              type="link"
              style={{float: 'right'}}
              onClick={async () => {
                AddPoint(index, props.plot?.props.points)
              }}
            >
              <PlusOutlined />
            </AntdButton>
          </div>
        ))}
      </Space> */}

      {props.plot && (
        <TransformerUIManager
          element={{...props.plot, type: 'plot'}}
          onChange={props.onPlotUpdated}
          transformerProps={props.transformerProps}
          onTransformerPropsChange={props.onTransformerPropsChange}
        />
      )}
    </div>
  )
}
